import { useLoaderData, type LinksFunction, type MetaFunction } from "react-router";
// import { cn } from "@/lib/utils"

import { WorkExperience } from "~/models/cv";
import './glitch-animation';
import { CornerDownRight, Terminal } from "lucide-react";
const name = "Richard Cotrina";
// const linkedinURL = "https://www.linkedin.com/in/rcotrina94?source=rcotrina.dev"
const titledTitle = "Software Developer";

export const workExperience: WorkExperience[] = [
    {
        company: "Freelance",
        position: "Full Stack & Mobile Developer",
        location: "Remoto",
        startDate: "2024",
        summary: `Desarrollo de aplicaciones móviles y web con Flutter para Android, iOS y Web. Integraciones con APIs y headless CMS, implementación de pipelines para dessarollo, test y despliegue.`,
        highlights: [],
        /*
        highlights: [
            "Aplicación de reservas con geolocalización, notificaciones push y CMS Directus",
            "App de radio online con flujos de audio en tiempo real usando Icecast y AzuraCast",
            "Pipelines CI/CD en GitLab para despliegue automático multiplataforma (Android/iOS/Web)"
        ],
        */
        skills: {
            technologies: [
                "Flutter", "Dart", "Android", "iOS", "Web", "Google SSO", "Directus", "PayloadCMS", "Strapi", "PostgreSQL",
                "Docker", "GitLab", "CI/CD", "Geolocation", "Push Notifications",
                "Icecast", "Shoutcast", "AzuraCast", "ZenFM",
            ]
        }
    },
    {
        company: "Cuida Co.",
        position: "Backend Developer",
        location: "Remoto, 🇵🇪",
        startDate: "2022",
        endDate: "2024",
        summary: `E-commerce de suscripción multicanal en productos de Salud, integración con pasarelas de pagos, sistemas de facturación, inventario, automatización en la gestión de pedidos, notificaciones y gestión de suscripciones`,
        highlights: [],
        skills: {
            technologies: [
                "Microservices", "NodeJS", "Git SCM", "AirTable", "Algolia", "Jenkins",
                "AWS Lambda", "AWS RDS/MySQL", "AWS Cognito", "AWS API Gateway",
                "AWS DynamoDB", "AWS ElastiCache", "AWS SES", "AWS SNS", "AWS S3",
                "AWS SQS", "AWS Amplify", "Jest", "GitLab", "Kushki", "MercadoPago"
            ]
        }
    },
    {
        company: "Indra",
        position: "Consultor TI",
        location: "Remoto, 🇵🇪",
        startDate: "2021",
        endDate: "2022",
        summary: `Grupo RÍMAC:
  - E-commerce de productos de salud - farmacia
  - E-commerce de productos de salud femenina
  - Plataforma de suscripción en productos de salud
  - Integraciones con pasarelas de pagos
  - Integraciones con herramientas no-code/low-code`,
        highlights: [],
        skills: {
            technologies: [
                "Microservices", "NodeJS", "Git SCM", "AirTable", "WebFlow", "GitLab",
                "TypeScript", "React/Next.js", "Python/Saleor", "GraphQL", "Jenkins", "Pytest",
                "AWS Lambda", "AWS RDS/MySQL", "AWS Cognito", "AWS API Gateway",
                "AWS S3", "AWS SQS", "AWS SNS", "AWS ElastiCache", "Jest", "Mailgun",
                "MailChimp", "Kushki", "Vue", "Zapier"
            ]
        }
    },
    {
        company: "Fractal Soluciones",
        position: "Full Stack Developer",
        location: "Lima, 🇵🇪",
        startDate: "2019",
        endDate: "2021",
        summary: `Grupo El Comercio:
  - Plataforma de Publicidad para anunciantes
  - Suscripciones a productos físicos y digitales
  - Portales Web diarios del grupo
  - Portal de Libro de Reclamaciones`,
        highlights: [],
        skills: {
            technologies: [
                "Microservices", "Python/Flask", "Python/Django", "XML/SOAP", "React",
                "AWS Lambda", "AWS Cognito", "AWS EC2", "AWS S3", "AWS API Gateway",
                "AWS RDS", "PostgreSQL", "Docker", "AWS ElastiCache", "Pytest", "PHP",
                "Google Ad Manager", "Google Ads", "Git SCM"
            ]
        }
    },
    {
        company: "Naremaster",
        position: "Consultor TI",
        location: "Guayaquil, 🇪🇨",
        startDate: "2018",
        endDate: "2019",
        summary: `Clipmaestro: Sistema ERP multitenant
Módulos de Contabilidad, Compra, Venta, Bancos, Inventario, Roles de Pago, Reportes y Administración
Integración con Servicio de Rentas Internas SRI
Firmas Digitales para Autenticación y Autorización`,
        highlights: [],
        skills: {
            technologies: [
                "Python/Django", "AngularJS", "NodeJS", "REST/JSON", "XML/SOAP",
                "PostgreSQL", "PL/SQL", "XadES_BES", "Apache", "nginx", "Sentry",
                "Git SCM", "GitLab", "Pytest", "SendGrid", "Mailgun", "Mailchimp",
            ]
        }
    },
    {
        company: "CACP Perú",
        position: "CTO",
        location: "Chimbote, 🇵🇪",
        startDate: "2016",
        endDate: "2018",
        summary: `Plataforma LMS con módulos de administración académica, administración CRM, y contabilidad y cobranza. Integración con sistemas de transmisión en vivo y tecnologías de comunicación y reportes en tiempo real`,
        highlights: [],
        skills: {
            technologies: [
                "Python/Django", "AngularJS", "NodeJS", "nginx", "Realtime", "SendGrid", "Mailgun", "Mailchimp",
                "PostgreSQL", "Firebase", "HTML5", "CSS3", "Bitbucket", "Pytest",
                "Vimeo", "YouTube", "Git", "Mercurial", "Gitlab", "CI/CD",
            ]
        }
    },
    {
        company: "Pytel",
        position: "Web Developer",
        location: "Chimbote, 🇵🇪",
        startDate: "2013",
        endDate: "2016",
        summary: `Desarrollo de Portales Web
  Plataformas para Web Data Extraction
  Desarrollo de sistemas en Tiempo Real`,
        highlights: [],
        skills: {
            technologies: [
                "Python/Django", "Python/Scrapy", "Python/Tornado", "Python/Celery",
                "PostgreSQL", "MySQL", "MongoDB", "Firebase", "Mercurial", "Bitbucket",
                "NodeJS", "AngularJS", "HTML5", "CSS3", "nginx", "Pytest", "SendGrid"
            ]
        }
    }
];


export const meta: MetaFunction = () => {
    return [
        { title: [name, titledTitle].join(" | ") },
        {
            name: "description",
            // content: "Portafolio personal y profesional donde comparto mis contribuciones en áreas clave como desarrollo de software para empresas (ERP, e-commerce, salud digital), robótica, IoT, ciberseguridad, DevOps, impresión 3D y bioinformática. Explora mis proyectos innovadores y experiencias transformadoras en tecnología."
            content: "Portafolio y experiencias en proyectos de áreas clave en diversas industrias.",
            keywords: "portafolio, portfolio, developer, software, desarrollador, ERP, e-commerce, ecommerce, digital, salud digital, digital health, robótica, robotics, IoT, ciberseguridad, cibersecurity, devops, 3D, 3D printing, impresión 3D, bioinformática, proyectos innovadores, 🇵🇪, Peru"
        },
    ];
};

export const links: LinksFunction = () => [
    {
        rel: "canonical",
        href: "https://rcotrina.dev/cv",
    },
]

type ILink = {
    url: string,
    label: string,
}

export async function loader() {
    const cvLinks: ILink[] = [
        { url: "mailto:jobs@rcotrina.dev", label: "jobs@rcotrina.dev" },
        { url: "https://linkedin.com/in/rcotrina94", label: "linkedin.com/in/rcotrina94" },
        { url: "https://github.com/rcotrina94", label: "github.com/rcotrina94" },
    ];

    return { cvLinks };
}


export default function Index() {

    const { cvLinks } = useLoaderData<typeof loader>();

    return <div className="bg-background">
        <div className="flex flex-col gap-4 p-6 md:p-10 container md:max-w-screen-lg print:w-a4 mx-auto">

            <div className="flex flex-col md:flex-row justify-between gap-2 md:items-end flex-wrap md:flex-nowrap">
                <div>
                    <h1 className="text-4xl font-medium tracking-tight text-balance">{name}</h1>
                    <h2 className="text-xl inline-flex gap-1">
                        <Terminal aria-hidden /><span>{titledTitle}</span>
                    </h2>
                </div>
                <aside>
                    <ul className="font-mono text-right">
                        {cvLinks.map((link) => (
                            <li key={link.url} className="text-sm">
                                <a href={link.url} rel="noopener">{link.label}</a>
                            </li>
                        ))}
                    </ul>
                </aside>
            </div>
            <hr />
            <section className="flex flex-col gap-8 print:gap-6 divide-y">
                {workExperience.map((job) => (
                    <article key={`${job.company}-${job.startDate}`} className="pt-6 flex flex-col md:flex-row gap-8 print:gap-4 break-inside-avoid">
                        <div className="md:w-96 print:w-80 flex flex-none flex-col">
                            <header className="flex flex-col md:justify-between">
                                <div>
                                    <h3 className="text-lg font-semibold">
                                        {job.company} <span aria-hidden className="text-muted-foreground font-normal">| </span><span className="text-muted-foreground font-normal"> {job.location}</span>
                                    </h3>
                                </div>
                                <div className="divide-x">
                                    <span>{job.position}</span>
                                    <span className="text-muted-foreground inline-flex whitespace-pre">
                                        <span>,<span>{" "}</span></span>
                                        <time dateTime={job.startDate}>{job.startDate}</time>
                                        <span className="w-3 text-center">-</span>
                                        {job.endDate ? <time dateTime={job.endDate}>{job.endDate}</time> : "∞"}
                                    </span>
                                </div>
                            </header>
                            <div className="flex flex-row">
                                <i className="px-1"><CornerDownRight size={20} /></i>
                                <div className="text-sm text-balance flex flex-col">
                                    <span className="whitespace-pre-line">{job.summary}</span>
                                    {job.highlights.length > 0 && (
                                        <ul className="list-disc list-inside text-sm text-muted-foreground">
                                            {job.highlights.map((item, i) => (
                                                <li key={i}>{item}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>

                            </div>
                        </div>
                        <div className="flex flex-col flex-1 flex-shrink ">
                            <div className="flex flex-row flex-wrap items-start justify-start gap-2">
                                {job.skills.technologies.map((tech) => (
                                    <span
                                        key={tech}
                                        className="flex-none text-xs px-2.5 py-1.5 print:px-2 print:py-1 rounded dark:text-muted dark:bg-foreground bg-muted font-semibold border border-border font-mono print:text-[10px]"
                                    >
                                        {tech}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </article>
                ))}
            </section>
        </div>
    </div>
}
